import gsap from 'gsap'
import store from '@/store'
import { playUnlock } from '@/lib/sound.js'

function expand() {
  /*const middle_button = this.$refs[5][0]
    const top_button = this.$refs[2][0]
    const right_button = this.$refs[6][0]
    const bottom_button = this.$refs[8][0]
    const left_button = this.$refs[4][0]*/
  const middle_button = document.getElementById('button-5')
  const top_button = document.getElementById('button-2')
  const right_button = document.getElementById('button-6')
  const bottom_button = document.getElementById('button-8')
  const left_button = document.getElementById('button-4')

  const middle_button_pos = middle_button.getBoundingClientRect()
  const tl = gsap.timeline()

  let triggered = false
  let progress = 0
  const unlocking = !store.getters.isActionUnlocked('expand')

  const progressInterval = setInterval(() => {
    store.commit('SET_UNLOCK_PROGRESS', progress)
    progress += 1
  }, 10)

  tl.to(middle_button, {
    scale: 3,
    color: '#468B18',
    borderColor: '#468B18',
    duration: 1,
    onComplete: () => {
      triggered = true
      clearInterval(progressInterval)
      store.commit('SET_UNLOCK_PROGRESS', 100)
      setTimeout(() => {
        store.commit('SET_UNLOCK_PROGRESS', 0)
      }, 300)
      store.commit('SET_BLOCK_CLICKS', [1, 2, 3, 4, 5, 6, 7, 8, 9])
      if (unlocking) {
        playUnlock()
      } else {
        store.commit('SET_MOVE_NAME_ANIMATE', store.getters.actions['expand'])
      }
    },
  })

  tl.to(
    middle_button,
    {
      scale: 1,
      color: '#cdf4dd',
      borderColor: '#cdf4dd',
      delay: unlocking ? 1 : 0,
      duration: 1,
      ease: 'elastic.out',
    },
    'rotate'
  )

  const top_button_pos = top_button.getBoundingClientRect()

  tl.to(
    top_button,
    {
      rotate: 90,
      duration: 1,
      delay: unlocking ? 1 : 0,
      transformOrigin: `center ${
        middle_button_pos.y - top_button_pos.y + middle_button_pos.height / 2
      }px`,
    },
    'rotate'
  )

  const right_button_pos = right_button.getBoundingClientRect()

  tl.to(
    right_button,
    {
      rotate: 90,
      duration: 1,
      delay: unlocking ? 1 : 0,
      transformOrigin: `${
        -(right_button_pos.x - middle_button_pos.x) +
        middle_button_pos.height / 2
      }px center`,
    },
    'rotate'
  )

  const bottom_button_pos = bottom_button.getBoundingClientRect()

  tl.to(
    bottom_button,
    {
      rotate: 90,
      duration: 1,
      delay: unlocking ? 1 : 0,
      transformOrigin: `center ${
        -(bottom_button_pos.y - middle_button_pos.y) +
        middle_button_pos.height / 2
      }px`,
    },
    'rotate'
  )

  const left_button_pos = left_button.getBoundingClientRect()

  tl.to(
    left_button,
    {
      rotate: 90,
      duration: 1,
      delay: unlocking ? 1 : 0,
      transformOrigin: `${
        middle_button_pos.x - left_button_pos.x + middle_button_pos.width / 2
      }px center`,
      onComplete: () => {
        let new_vals = [...store.getters.button_vals]
        const old_five = new_vals[5]
        new_vals[5] = new_vals[1]
        new_vals[1] = new_vals[3]
        new_vals[3] = new_vals[7]
        new_vals[7] = old_five
        store.commit('SET_BUTTON_VALS', new_vals)
        if (unlocking) {
          store.dispatch('unlock_action', 'expand')
          setTimeout(() => {
            store.commit('SET_SHOW_UNLOCK_DIALOG', true)
          }, 500)
        } else {
          store.commit('SET_BLOCK_CLICKS', [])
          setTimeout(() => {
            store.commit('SET_STAGE', store.getters.nextStage)
          }, 500)
        }
      },
    },
    'rotate'
  )

  tl.set(top_button, { rotate: 90, transformOrigin: 'center center' })
  tl.set(right_button, { rotate: 90, transformOrigin: 'center center' })
  tl.set(bottom_button, { rotate: 90, transformOrigin: 'center center' })
  tl.set(left_button, { rotate: 90, transformOrigin: 'center center' })

  tl.to(top_button, { rotate: 0, ease: 'back.out', duration: 0.5 }, 'reorient')
  tl.to(
    right_button,
    { rotate: 0, ease: 'back.out', duration: 0.5 },
    'reorient'
  )
  tl.to(
    bottom_button,
    { rotate: 0, ease: 'back.out', duration: 0.5 },
    'reorient'
  )
  tl.to(
    left_button,
    {
      rotate: 0,
      ease: 'back.out',
      duration: 0.5,
      onComplete: () => {
        store.commit('SET_CODE_SCREEN', 'CodeScreenBase')
        console.log('RESETTING BUTTON styles')
        resetAllButtons()
      },
    },
    'reorient'
  )

  const mouseup_listener = () => {
    clearInterval(progressInterval)
    store.commit('SET_UNLOCK_PROGRESS', 0)
    if (!triggered) {
      tl.kill()
      gsap.to(middle_button, {
        scale: 1,
        color: '#cdf4dd',
        borderColor: '#cdf4dd',
        duration: 0.5,
        ease: 'elastic.out',
        onComplete: () => {
          resetAllButtons()
        },
      })
    }
    window.removeEventListener('touchend', mouseup_listener)
    window.removeEventListener('mouseup', mouseup_listener)
  }
  window.addEventListener('touchend', mouseup_listener)
  window.addEventListener('mouseup', mouseup_listener)
}

function resetAllButtons() {
  const button_ids = [
    'button-1',
    'button-2',
    'button-3',
    'button-4',
    'button-5',
    'button-6',
    'button-7',
    'button-8',
    'button-9',
  ]
  button_ids.forEach((b) => resetButtonStyle(b))
}

function resetButtonStyle(button_id) {
  const button = document.getElementById(button_id)
  gsap.set(button, { clearProps: 'all' })
}

export default expand
